import { useQuery } from '@tanstack/react-query'
import { ArrowLeft, LoaderCircle } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'
import { Header } from '../components/Header'
import { ProductShowcase } from '../components/ProductShowcase'
import { Reviews } from '../components/Reviews'
import { apiRequest } from '../lib/api'
import type { Product } from '../types'

export function ProductPage() {
  const { slug = '' } = useParams()

  const productQuery = useQuery({
    queryKey: ['product', slug],
    queryFn: () => apiRequest<{ data: Product }>(`/api/products/${slug}`),
    enabled: slug.length > 0,
    retry: 1,
  })
  const product = productQuery.data?.data

  return (
    <div className="page-shell">
      <Header />
      <main>
        {productQuery.isLoading ? (
          <div className="dashboard-loading section-frame"><LoaderCircle className="spin" /><span>Loading product…</span></div>
        ) : !product ? (
          <div className="result-page section-frame">
            <section className="result-card">
              <span className="eyebrow">ERROR // 404</span>
              <h1>Product not found.</h1>
              <p>This product does not exist or is no longer available.</p>
              <Link className="button button--primary" to="/#products">Back to the catalog</Link>
            </section>
          </div>
        ) : (
          <>
            <div className="section-frame product-page__back">
              <Link to="/#products"><ArrowLeft size={14} /> All products</Link>
            </div>
            <section className="product-section section-frame">
              <ProductShowcase product={product} />
            </section>
            <section className="reviews-section section-frame" id="reviews">
              <Reviews product={product} />
            </section>
          </>
        )}
      </main>
    </div>
  )
}
